import { Button } from 'braid-design-system';
import type React from 'react';

import { NEXT_ROLE, PROFILE_VISIBILITY } from 'src/components/Router';
import { Link, type LinkComponent } from 'src/components/Router/Link';
import { analyticsClient } from 'src/modules/analytics';
import type { AnalyticsCurrentPageSection } from 'src/modules/analytics/types';
import type { Card } from 'src/types';
import type { ProfileScoreTipAction } from 'src/types/graphql';

interface TipLinkProps {
  nudgeText: string | React.ReactElement;
  action: ProfileScoreTipAction;
  component?: LinkComponent;
  [key: string]: any;
}

export const TipLink = ({
  nudgeText,
  action,
  component = Button,
  ...restProps
}: TipLinkProps) => {
  const { card, field, item } = action;

  const isProfileVisibility = card === 'profile-visibility';

  const linkingCard = () => {
    if (card === NEXT_ROLE) {
      return field;
    }

    return isProfileVisibility ? PROFILE_VISIBILITY : card;
  };

  return (
    <Link
      card={linkingCard() as Card}
      mode="EDIT"
      component={component}
      params={{
        focusOn: field,
        id: item,
      }}
      onClick={() => {
        analyticsClient.cardOpened({
          origin: 'top nudge',
          currentPageSectionState: 'add',
          currentPageSection: linkingCard() as AnalyticsCurrentPageSection,
        });
      }}
      data={{ testid: 'tip-link' }}
      {...restProps}
    >
      {nudgeText}
    </Link>
  );
};
